'use client';

import React from 'react';

// Комментарий на русском: дефолтные цвета обрамления.
const DEFAULT_ONLINE_COLOR = '#22c55e';
const DEFAULT_OFFLINE_COLOR = '#64748b';

// Комментарий на русском: нормализация hex-цвета.
function normHex(v?: string | null, fallback = DEFAULT_ONLINE_COLOR) {
  const s = String(v || '').trim();
  return /^#[0-9a-fA-F]{6}$/.test(s) ? s.toLowerCase() : fallback;
}

// Комментарий на русском: преобразование hex в RGB triplet для CSS-переменных.
function hexToRgbTriplet(hex: string, fallback = DEFAULT_ONLINE_COLOR) {
  const h = normHex(hex, fallback);
  const r = parseInt(h.slice(1, 3), 16) || 0;
  const g = parseInt(h.slice(3, 5), 16) || 0;
  const b = parseInt(h.slice(5, 7), 16) || 0;
  return `${r} ${g} ${b}`;
}

function clampInt(v: unknown, min: number, max: number, def: number) {
  const n = Number(v);
  if (!Number.isFinite(n)) return def;
  return Math.max(min, Math.min(max, Math.round(n)));
}

export function AvatarFx(props: {
  sizeClass: string;
  avatarUrl?: string | null;
  alt?: string;
  fallback?: string;
  isOnline?: boolean;
  fxColor?: string | null;
  fxThickness?: number | null;
  fxGlow?: number | null; // 0..100
  // Комментарий на русском: цвет обрамления для офлайн-состояния.
  fxOfflineColor?: string | null;
  className?: string;
  innerClassName?: string;
}) {
  const color = normHex(props.fxColor, DEFAULT_ONLINE_COLOR);
  const offlineColor = normHex(props.fxOfflineColor, DEFAULT_OFFLINE_COLOR);
  const w = clampInt(props.fxThickness, 0, 10, 2);
  const glow = clampInt(props.fxGlow, 0, 100, 0);
  const rgb = hexToRgbTriplet(color, DEFAULT_ONLINE_COLOR);
  const offlineRgb = hexToRgbTriplet(offlineColor, DEFAULT_OFFLINE_COLOR);
  const g = glow / 100;
  const online = !!props.isOnline;

  // Комментарий на русском: CSS-переменные для онлайн/офлайн эффектов.
  const style = {
    ['--af-rgb' as any]: rgb,
    ['--af-offline-rgb' as any]: offlineRgb,
    ['--af-w' as any]: `${w}px`,
    ['--af-g' as any]: g,
  } as React.CSSProperties;

  return (
    <span
      className={`${props.sizeClass} relative inline-flex rounded-full lisad-avatar-fx ${online ? 'lisad-avatar-fx--online' : 'lisad-avatar-fx--offline'} ${props.className || ''}`}
      style={style}
      aria-label={props.alt || 'Аватар'}
    >
      <span
        className={`absolute inset-0 rounded-full overflow-hidden flex items-center justify-center text-site-text font-bold select-none ${
          props.innerClassName || 'bg-site-action'
        }`}
      >
        {/* Комментарий на русском: если фото нет — показываем непрозрачный силуэт (паспортный стиль). */}
        <img
          src={props.avatarUrl || '/uploads/chat_room_avatars/lisad_default_avatar.gif'}
          alt={props.alt || 'Аватар'}
          className="w-full h-full object-cover"
        />
      </span>
    </span>
  );
}


